<template>
	<div class="table_div">
		<el-form :inline="true" class="select_form">
			<el-form-item>
				<h3>行业管理</h3>
			</el-form-item>
			<el-form-item>
				<el-button type='primary' @click="addIndustry">增加行业</el-button>
			</el-form-item>
			<el-form-item>
				<el-button type='primary' @click="infoData.industryShow = true">编辑行业</el-button>
			</el-form-item>
			<el-form-item>
				<el-popconfirm title="确定删除吗?" @confirm="handleClickDel">
					<template #reference>
						<el-button type="danger">删除行业</el-button>
					</template>
				</el-popconfirm>
			</el-form-item>
		</el-form>
		<el-card style='margin:5px'>
			<el-tree :data="infoData.tableData" :props="defaultProps" @node-click="handleNodeClick" v-loading='infoData.ELloading'/>
		</el-card>
		<el-dialog v-model="infoData.industryShow" title="增加/修改行业" width="50%" :before-close="handleFcancel">
			<el-form v-model="infoData.form" label-position="left" label-width="100px">
				<el-form-item label="父级目录" v-if='!infoData.form.id'>
					<el-cascader v-model="infoData.form.parentId" :options="infoData.parList"
						:props="{ checkStrictly: true ,value:'id',label:'text'}" clearable
						placeholder="请选择父级目录(不选就是根目录)" style='width:100%'>
						<template #default="{ node, data }">
							<span>{{ data.text }}</span>
						</template>
					</el-cascader>
				</el-form-item>
				<el-form-item label="行业名称">
					<el-input v-model="infoData.form.name" />
				</el-form-item>
				<el-form-item label="行业代码">
					<el-input v-model="infoData.form.code" />
				</el-form-item>
				<el-form-item label="行业等级">
					<el-input-number v-model="infoData.form.grade" :min="0" label="请输入行业等级" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="handleFcancel">取 消</el-button>
				<el-button type="primary" :loading="infoData.loading" @click="handleEdit">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		onMounted,
		reactive
	} from "vue-demi";
	import api from "../../http/apis";
	import {
		ElMessageBox,
		ElMessage
	} from "element-plus";
	import {
		useStore
	} from "vuex";
	export default {
		setup() {
			const store = useStore();
			const infoData = reactive({
				tableData: [],
				industryId: 0,
				ELloading:false,
				loading: false,
				industryShow: false,
				form: {
					id:0,
					grade: 1
				},
				parList: []
			});
			const defaultProps = {
				children: 'children',
				label: 'text',
			};
			const getTableData = async () => {
				infoData.ELloading = true
				const {
					data
				} = await api.companyApi.getIndustryTree();
				if (data.isSuccessful) {
					infoData.tableData = data.resultObj
					infoData.parList = data.resultObj
					infoData.ELloading = false
				} else if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					});
					infoData.ELloading = false
				} else {
					ElMessage({});
				}
			};
			getTableData()
			return {
				infoData,
				getTableData,
				defaultProps
			};
		},
		methods: {
			async handleClickDel() {
				if (this.infoData.industryId == 0) {
					ElMessage({
						message: '请选中行业后再删除！',
						type: "error",
					});
				} else {
					const {
						data
					} = await api.companyApi.deleteCategory(this.infoData.industryId);
					if (data.isSuccessful) {
						ElMessage({
							message: data.resultMsg,
							type: "success",
						});
						this.getTableData()
					} else if (data.resultMsg) {
						ElMessage({
							message: data.resultMsg,
							type: "error",
						});
					} else {
						ElMessage({});
					}
				}
			},
			async handleEdit() {
				if(this.infoData.form.parentId && typeof(this.infoData.form.parentId) != 'number'){
					this.infoData.form.parentId.forEach((item) => {
						this.infoData.form.parentId = item
					})
					this.infoData.form.id = 0
				}
				// console.log(this.infoData.form)
				// // console.log(this.infoData.form)
				const {
					data
				} = await api.companyApi.saveCategory(this.infoData.form);
				if (data.isSuccessful) {
					ElMessage({
						message: data.resultMsg,
						type: "success",
					});
					this.infoData.industryShow = false
					this.infoData.form = {}
					this.getTableData()
				} else if (data.resultMsg) {
					ElMessage({
						message: data.resultMsg,
						type: "error",
					});
				} else {
					ElMessage({});
				}
			},
			addIndustry(){
				this.infoData.industryShow = true
				this.infoData.form = {}
			},
			handleNodeClick(data) {
				// console.log(data)
				this.infoData.form.name = data.text
				this.infoData.form.code = data.code
				this.infoData.form.grade = parseInt(data.level) 
				this.infoData.form.id = data.id
				this.infoData.form.parentId = data.parentId
				
				this.infoData.industryId = data.id
			},
			handleFcancel() {
				this.infoData.industryShow = false
				this.infoData.form = {}
			},
		},
	};
</script>

<style scoped lang='scss'>
	@use "../../assets/scss/table.scss"as *;
</style>
